import { ColumnSubType, Column } from '@scale/compass-shared/types';

export const getTaskIdColumn = (retrievedOutput: any) => {
  return retrievedOutput?.response?.schema?.find(
    (col: Column) => col.subType === ColumnSubType.TASK_ID,
  )?.header;
};

export const getWorkerIdColumn = (retrievedOutput: any) => {
  return retrievedOutput?.response?.schema?.find(
    (col: Column) => col.subType === ColumnSubType.WORKER_ID,
  )?.header;
};

export const getSampleTaskId = (retrievedOutput: any, taskIdColumn: string) => {
  const column = taskIdColumn || 'taskId';
  return retrievedOutput?.response?.data?.[0]?.[column];
};

export const getMetadataColumns = (retrievedOutput: any) => {
  return retrievedOutput?.response?.schema?.filter((col: Column) => col.header !== 'taskId') || [];
};

export const getSampleValue = (retrievedOutput: any, columnHeader: string) => {
  const value = retrievedOutput?.response?.data?.[0]?.[columnHeader];
  const trimmedValue = typeof value === 'string' ? value.trim() : value;
  if (Array.isArray(value) && value.length === 0) {
    return '<empty>';
  }
  if (typeof value === 'boolean') {
    return value.toString();
  }
  if (typeof trimmedValue === 'string' && trimmedValue.length > 200) {
    return trimmedValue.slice(0, 200) + `... (${trimmedValue.length - 200} additional characters)`;
  }
  return trimmedValue === undefined || trimmedValue === null || trimmedValue === ''
    ? '<empty>'
    : value;
};
